export const constants = {
    // it should be equal to .e2-page__header--scrolled--reduced heights
    headerScrolledHeightDesktop: 120,
    headerScrolledHeightMobile: 40,
    commonMarginTop: 15,
    stickyBarHeight: 40,
    mobileScrollObserverHeight: 52,
    stickyRowHeight: 75,
    FIELD_NAMES: {
        postalCode: 'postalCode',
        houseNumber: 'line2',
        addAddress: 'addAddress',
        deliveryTime: 'deliveryTime',
        billingAddress: 'billingAddress',
    },
    headerHeight: 65,
    postLocatorName: 'post-locator',
    ccDeliveryName: 'pickup-express',
    ccDeliveryType: 'pickup_express',
    deliveryModeTypeHome: 'home',
    deliveryModeTypePickup: 'pickup',
    deliveryModeTypeExpress: 'express',
    deliveryModeTypeEmail: 'email',
    ppDeliveryType: 'postPointShipping',
    numberOfReviewItemsPerPage: 6,
    voucherApiUrl: '/vouchers',
    giftcardApiUrl: '/giftcards',
    defaultPostPointValue: 0,
    configurationKeys: {
        postPointSearchType: 'postpoint.store.search.api',
    },
    swissPostPoint: 'SWISSPOSTPOINT',
    cartPageUrl: '/cart',
};

export const serverErrors = {
    IllegalStateError: 'IllegalStateError',
    Unauthorized: 'Unauthorized',
};

export const deliveryDateServerErrors = {
    OUT_OF_STOCK_FOR_HOME_DELIVERY: 'delivery.estimation.product.out.of.stock',
    OUT_OF_STOCK_FOR_PICKUP_FROM_STORE:
        'delivery.estimation.pick.up.from.store.product.out.of.stock',
    STORE_NOT_FOUND: 'delivery.estimation.store.not.found',
    EXCLUSIVE_PRODUCT: 'delivery.estimation.online.exclusive.product',
};

export const toDisableCopyPasteFields = ['uidConfirm', 'passwordConfirm', 'newEmailCheck'];
export const toPreventAutofillFields = ['uid', 'uidConfirm', 'password', 'passwordConfirm'];
export const toPreventFillCardNumber = ['cardNumber'];

export const excludedErrorTypesForGlobalMessages = [
    'ValidationError',
    'IllegalArgumentError',
    'DuplicateUidError',
    'PasswordMismatchError',
    'CommerceCartModificationRuntimeError',
];

export const cookieNames = {
    isCheckoutRegistration: 'isCheckoutRegistration',
    tokenType: 'token_type',
    tokyBepSso: 'toky_bep_sso',
    eGiftCardCartEnding: '-eGiftCard-cart',
    showNotifyMe: '-show-notify-me',
};

export const socialNames = {
    FACEBOOK: 'facebook',
    GOOGLE: 'google',
};

export const deliveryModes = {
    POST_POINT: 'POST_POINT',
};

export const providerIds = {
    [socialNames.FACEBOOK]: 'FACEBOOK',
    [socialNames.GOOGLE]: 'GOOGLE',
};

export const backSocialActions = {
    autologin: 'AUTOLOGIN',
    register: 'REGISTER',
    login: 'LOGIN',
    connect: 'CONNECT',
};

export const loginErrors = {
    forbidden: 'forbidden',
    invalidGrant: 'invalid_grant',
    invalidSocialProfileGrant: 'invalid_social_profile_grant',
    invalidSocialProfileToken: 'invalid_social_profile_token',
    invalidSocialProfileResource: 'invalid_social_profile_resource',
    authLocked: 'auth_locked',
    general: 'general',
};

export const SHARED_ACTIONS = {
    setPinCodeStatus: 'SET_PIN_CODE_STATUS',
    checkPinCode: 'CHECK_PIN_CODE',
    setIsPinCodeOrDOBValid: 'SET_IS_PIN_CODE_OR_DOB_VALID',
};

export const formFieldsConstants = {
    date: 'DATE',
    hidden: 'HIDDEN',
    defaultDateFormatter: 'DD-MM-YYYY',
};

export const datePickerConstants = {
    DEFAULT_START_YEAR: 1908,
    DEFAULT_START_DATE: '1900-01-01',
    ONE_DAY_IN_MS: 24 * 60 * 60 * 1000,
    YEARS_PER_PAGE: 30,
    DEFAULT_FORMAT: 'YYYY-MM-DD',
    SELECT_ORDER: 'DD-MM-YYYY',
    TODAY: 'TODAY',
    FORMAT_PANELS: {
        YEARS: 'YYYY',
        MONTHS: 'MM',
        DAYS: 'DD',
    },
    DISPLAY_MODES: {
        TEXT: 'text',
        SELECT: 'select',
        CALENDAR: 'calendar',
    },
};

export const timePickerConstants = {
    HOUR_STEP: 1,
    MINUTE_STEP: 5,
    MAX_HOUR_VALUE: 23,
    MAX_MINUTE_VALUE: 59,
    MIN_FIELD_VALUE: 0,
    TIME_SEPARATOR: ':',
    FORMAT_PANELS: {
        HOURS: 'HH',
        MINUTES: 'mm',
    },
};

export const miniCartPopoverStatusConstants = {
    MAX_ORDER_QTY_EXCEEDED: 'maxOrderQuantityExceeded',
    LOW_STOCK: 'lowStock',
    SUCCESS: 'success',
};

export const cartTypeConstants = {
    DIGITAL: 'DIGITAL',
    REGULAR: 'REGULAR',
    MIXED: 'MIXED',
};

export const paymentErrors = {
    termsNotAccepted: 'termsNotAccepted',
    paymentNotSelected: 'paymentNotSelected',
    deliveryStoreNotSelected: 'deliveryStoreNotSelected',
    cartNotFound: 'cartNotFound',
    zeroBalanceGiftCardError: 'zeroBalanceGiftCardError',
    orderFailedText: 'orderFailedText',
    iFrameError: 'iFrameError',
    iFrameSaveCardError: 'iFrameSaveCardError',
    fetchIframeError: 'fetchIframeError',
    billingAddressNotSelected: 'billingAddressNotSelected',
    removeCardFailed: 'removeCardFailed',
    removeCardSuccess: 'removeCardSuccess',
    orderCannotBeFullFilledWithLC: 'orderCannotBeFullFilledWithLC',
    placeOrderCartValidationResponseError: 'placeOrderCartValidationResponseError',
    agreementsNotAccepted: 'agreementsNotAccepted',
    minimumOrderThresholdForPWP: 'minimumOrderThresholdForPWP',
    getSessionError: 'getSessionError',
    shippingAddressNotSelected: 'shippingAddressNotSelected',
    cardNotSelected: 'cardNotSelected',
    cartNotSame: 'cartNotSame',
};

export const stockMod = {
    inStock: 'in-stock',
    lowStock: 'low-stock',
    outOfStock: 'out-of-stock',
};

export const gwpLayoutStrategies = {
    below: 'GWP_BELOW_ITEM',
    above: 'GWP_ABOVE_ITEM',
    bottom: 'GWP_ON_BOTTOM',
};

export const freeSamplesSortingTypes = {
    stockLevel: 'STOCK_LEVEL',
    recentlyAdded: 'RECENTLY_ADDED',
    alphabetical: 'ALPHABETICAL',
};

export const dialogWithProductDetailsName = 'product-details-popup';
export const selectWishlistDialogName = 'select-wishlist-popup';
export const externalReviewsVendorPopupName = 'external-reviews-vendor-popup';
export const rtsDialogName = 'rts-pickup';
export const stbDialogName = 'swipe-to-buy';
export const colorVariantSelector = 'color-variant-selector';
export const sizeVariantSelector = 'size-variant-selector';
export const mixedCartForbiddenPopupName = 'mixed-cart-forbidden-popup';
export const gwpChoicePopup = 'gwp-choice-popup';
export const freeItem = 'FREE ITEM';
export const checkoutFlow = 'checkout';
export const SHOULD_SCROLL_KEY = 'should-scroll-after-page-load';

export const dialogConstants = {
    getParamName: 'isPopupOpen',
};

export const storageNames = {
    lastUsedStore: 'lastUsedStore',
    freeSamplesRefused: 'freeSamplesRefused',
    lastPickupName: 'last-pickup-name',
    lastStoreLocatorQuery: 'last-store-locator-query',
};

export const orderConfirmationRegistration = {
    clearOnRedirect: true,
    errorMessagesSelector: 'e2-connected-message[type=ERR]',
    typesOfGlobalErrors: ['login', 'IllegalArgumentError'],
};

export const addAddressFormSuccessMessage = {
    id: 'addressBookMessage',
    source: 'addAddressSuccessMessage',
    clearOnRedirect: true,
};

export const editAddressFormSuccessMessage = {
    id: 'addressBookMessage',
    source: 'editAddressSuccessMessage',
    clearOnRedirect: true,
};

export const removeAddressBookSuccessMessage = {
    id: 'addressBookMessage',
    source: 'removeAddressSuccessMessage',
    clearOnRedirect: true,
};

export const setDefaultAddressBookSuccessMessage = {
    id: 'addressBookMessage',
    source: 'setDefaultAddressSuccessMessage',
    clearOnRedirect: true,
};

export const emailChangeFormSuccessMessage = {
    id: 'emailChangeSuccessMessage',
    clearOnRedirect: true,
};

export const emailChangeFormErrorMessage = {
    id: 'emailChangeErrorMessage',
    clearOnRedirect: true,
};

export const digitalCardAddedSuccessMessage = {
    id: 'digitalCardAddedSuccessMessage',
    clearOnRedirect: true,
};

export const orderCancelSuccessMessage = {
    id: 'orderCancelSuccessMessage',
    clearOnRedirect: true,
};

export const orderCancelErrorMessage = {
    id: 'orderCancelErrorMessage',
    clearOnRedirect: true,
};

export const physicalCardAddedSuccessMessage = {
    id: 'physicalCardAddedSuccessMessage',
    clearOnRedirect: true,
};

export const editSavedCardErrorMessage = {
    id: 'editSavedCardErrorMessage',
    clearOnRedirect: true,
};

export const passwordChangeFormSuccessMessage = {
    id: 'passwordChangeSuccessMessage',
    clearOnRedirect: true,
};

export const phoneNumberChangeFormSuccessMessage = {
    id: 'phoneNumberChangeFormSuccessMessage',
    clearOnRedirect: true,
};

export const counterDirection = {
    dec: 'dec',
    inc: 'inc',
};

export const videoUrls = {
    YOUTUBE: 'https://www.youtube.com/embed/',
    VIMEO: 'https://player.vimeo.com/video/',
};

export const keyboard = {
    backspace: 8,
};

export const cartSuccessStatuses = [
    'success',
    'maxOrderQuantityExceeded',
    'lowStock',
    'minOrderQuantityNotReached',
];

export const constraintsSorting = {
    firstType: 'required',
    nestedType: 'form',
};

export const paymentSlots = {
    PAYPAL: 'paypal',
    CREDIT: 'card',
    INVOICE: 'invoice',
    COD: 'cashOnDelivery',
    MCOD: 'mitcashondelivery',
    EPS: 'eps',
    SLOT: 'slot',
    OFFLINE: 'offline',
    SEAMLESS: 'SEAMLESS',
    TWINT: 'twint',
    KLARNA: 'klarna',
    REDIRECT: 'REDIRECT',
    MONETAWEB: 'monetawebcard',
    SAFERPAY_CARD: 'saferpaycard',
    SUCCESS: 'SUCCESS'
};

export const orderConfirmationUrl = {
    CONFIRMATION: '/orderConfirmation',
};

export const paymentConstants = {
    MASTER: 'master',
    VISA: 'visa',
    DINNER: 'dinner',
    AMERICAN: 'amex',
    MAESTRO: 'maestro',
    GIFTCARD: 'giftcard',
    PWP: 'payWithPoints',
    Loyalty: 'loyalty',
    SUPERUP: 'superup',
};

export const newCard = {
    id: 'NEW_CARD',
    cardType: { code: '' },
    hideAdditionalDetails: true,
};

export const addressBookType = {
    FULL: 'full',
    BILLING: 'billing',
    BILLING_ADDRESS: 'billingAddress',
    SHIPPING_ADDRESS: 'shippingAddress',
};

export const addressTypes = {
    INDIVIDUAL: 'INDIVIDUAL',
    CORPORATE: 'CORPORATE',
};

export const realTimeStockErrors = {
    NO_STORE_FOUND: 'no-store',
    NO_STORE_FOUND_PRODUCT: 'no-store-product',
    RTS_ERROR: 'rts-error',
};

export const wishlistErrors = {
    EXPIRED_SHARED_WISHLIST_ERROR: 'ExpiredSharedWishlistError',
};

export const adjustConfirmationDialog = 'remove-unavailable-products';
export const enterPhoneNumberDialog = 'enter-phone-number';
export const adjustMaxAllowedProducts = 'adjust-max-allowed-products';

export const checkoutAddressForm = {
    shippingForm: 'add-delivery-address',
    billingForm: 'add-billing-address',
};

export const checkoutAddressEditFrom = {
    shippingAddress: 'add-edit-checkout-shipping-address-popup',
    billingAddress: 'add-edit-checkout-billing-address-popup',
};

export const addressStoreName = {
    common: 'addressesForm',
    shipping: 'shippingAddressesForm',
    billing: 'billingAddressesForm',
};
export const addressPopup = {
    common: 'add-edit-address-popup',
    shipping: 'add-edit-shipping-address-popup',
    billing: 'add-edit-billing-address-popup',
};
export const addressPopupByStoreName = {
    [addressStoreName.common]: addressPopup.common,
    [addressStoreName.shipping]: addressPopup.shipping,
    [addressStoreName.billing]: addressPopup.billing,
};

export const ignorePropertiesFromStorageSync = [
    'auth.loading',
    'address.loading',
    'user.loading',
    'cart.loading',
    'orders.loading',
    'order.loading',
    'wishlists.loading',
    'notifyme.loading',
    'product.loading',
    'analytics.gtmCounter',
];

export const orderDocument = {
    INVOICE_DOCUMENT: 'invoiceDocument',
};

export const getParameterNames = {
    wishlistCodeForAddToCart: 'wishlistCode',
};

export const featureNames = {
    freeSamples: 'FREE_SAMPLES',
    giftOptions: 'GIFTOPTIONS',
    giftMessage: 'GIFT_MESSAGE',
    engraving: 'ENGRAVING',
};

export const promotionTypes = {
    percentDiscount: 'PERCENT_DISCOUNT',
};

export const reviewUsefulnessVote = {
    useful: 'USEFUL',
    notUseful: 'NOT_USEFUL',
};

export const timeUnitConstants = {
    minutes: 'Minutes',
    seconds: 'Seconds',
    hours: 'Hours',
};

export const relationalOperatorsConstants = {
    moreThan: 'more than',
    lessThan: 'less than',
};

export const limitativeCheckParam = 'limitativeChecked';
export const redirectLimitationBrandsUrlAfterCheckoutLogin = `/cart?${limitativeCheckParam}=true`;
export const NO_INFO_STOCK = 'noInfo';
export const registrationPrefillFields = [
    'firstName',
    'middleName',
    'lastName',
    'gender',
    'postalCode',
    'pobox',
    'line1',
    'line2',
    'line3',
    'building',
    'remarks',
    'phone',
    'mobileNumber',
    'town',
    'dateOfBirth',
    'sms',
    'email',
    'jobTitle',
    'title',
];

export const personaClickEventsType = {
    internalEmail: 'INTERNAL_EMAIL',
    internalSms: 'INTERNAL_SMS',
    internalWhatsapp: 'WHATS_APP',
    generalTracking: 'track',
    profileTracking: 'profile',
    preferencesTracking: 'subscription',
    manage: 'manage',
    set: 'set',
    homeTracking: 'delivery',
    pickupTracking: 'pickup_point',
    searchType: 'search',
    addToCartType: 'cart',
    removeFromCartType: 'remove_from_cart',
    addToWishlistType: 'wish',
    removeFromWishlistType: 'remove_wish',
    orderConfirmationType: 'purchase',
    notifyMeTrack: 'subscribe_trigger',
    notifyMeType: 'product_available',
    segmentTrack: 'segment',
    segmentAdd: 'add',
    emailType: 'email',
    smsType: 'sms',
    whatsapp: 'Whatsapp',
    physicalLoyaltyCard: 'physical-loyalty-card',
};

export const anonymousDefaultAddress = {
    email: 'anonymous@anonymous.com',
    firstName: 'anonymous',
    lastName: 'anonymous',
    gender: 'NOTTOSAY',
};

export const personalInformation = {
    ORDER_LABEL: 'ABOUT_MY_ORDER',
};

export const deliveryModeCodes = {
    homeDelivery: 'home-mat-shipping',
    clickAndCollectExpress: 'mat-pickup-express',
    clickAndCollect: 'pickup-mat',
    pickupPoints: 'post-office',
};

export const myAccountUrls = {
    myAccountOrders: '/my-account/orders',
    myAccountOrder: 'my-account/order/',
};

export const errorStatusToReason = {
    401: serverErrors.Unauthorized,
    403: serverErrors.Unauthorized,
};

export const loyaltyStatuses = {
    registered: 'REGISTERED',
    unregisteredLoyaltyMember: 'UNREGISTERED_LOYALTY_MEMBER',
    unregisteredNonLoyaltyMember: 'UNREGISTERED_NON_LOYALTY_MEMBER',
    unregisteredCrmUnavailable: 'UNREGISTERED_CRM_UNAVAILABLE',
};

export const externalCatalogTypes = {
    content: 'contentSuggestions',
    category: 'categories',
    brand: 'brands',
    product: 'products',
};

export const registrationServerError = {
    EMAIL_ALREADY_EXIST: 'Dynamic_UserSignUpWsDTO_uid_db_validation',
};

export const registrationErrorType = {
    ALREADY_EXIST: 'already_exists',
};

export const validRegistrationValidationForm = ['registrationForm', 'checkout-registration'];

export const dlrTrackingEvents = {
    START: 'start credentials',
    SUBMIT: 'submit credentials',
    COMPLETE: 'complete credentials',
};

export const lostOrStolenCardUpdateSuccess = {
    text: 'lostOrStolenCardUpdateSuccess',
};

export const giftOptionsType = {
    GIFTOPTIONS_MESSAGE: 'GIFTOPTIONS_MESSAGE',
    GIFTOPTIONS: 'GIFTOPTIONS',
};

export const pageType = {
    pdp: 'product detail page',
};

export const interestSelectionComponent = {
    parent: 'InterestSelectionComponent',
};

export default constants;
